var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad_loader"},[_c('div',{staticClass:"ad_loader__spinner"},[_c('Spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }